import React, { useEffect, useRef, useState } from 'react';
import { useParams, useNavigate, useLocation } from 'react-router-dom';
import './ViewAdditionalDoc.scss';
import {
    getAddDocDetailByID,
    uploadPendingAddDoc,
} from '../../services/api/AddDocApi';
import { useToast } from '../../context/ToastContext';
import { useAuth } from '../../context/AuthContext';
import { useLoading } from '../../context/LoadingContext';
import { getDownloadURL, ref, uploadBytesResumable } from 'firebase/storage';
import { storage } from '../../utils/firebase';
import { BiUpload } from 'react-icons/bi';
import { getUserData } from '../../services/api/AuthApi';
import { getBothCourtCasesDetailsByCourtRef } from '../../services/api/CasesApi';
import { uploadFileWithProgress } from '../../utils/ftpUploadUtils';
import { FiUserPlus,FiClock,FiUser,FiTag} from 'react-icons/fi';


export const ViewAdditionalDoc = () => {
    const { id } = useParams();
    const navigate = useNavigate();
    const { role, company } = useAuth();

    const [doc, setDoc] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');
    const [creatorName, setCreatorName] = useState('');
    const [clientName, setClientName] = useState('');
    const [partyNames, setPartyNames] = useState('');

    const [file, setFile] = useState(null);
    const [uploading, setUploading] = useState(false);
    const [uploadProgress, setUploadProgress] = useState(0);
    const [documentUrl, setDocumentUrl] = useState('');
    const fileInputRef = useRef(null);

    const { showToast } = useToast();
    const { showLoading, hideLoading } = useLoading();
    const location = useLocation();

    const courtref = location.pathname.split('/')[4];

    // Fetch document and related data
    useEffect(() => {
        const fetchDocDetails = async () => {
            try {
                showLoading("Loading document details...");
                const response = await getAddDocDetailByID(id);
                const docData = response.data;
                setDoc(docData);

                const createdById = docData.createdBy;
                console.log(createdById, "createdById")
                const [creatorRes, clientRes, partyRes] = await Promise.all([
                    getUserData(docData.createdBy),
                    getUserData(docData.clientId),
                    getBothCourtCasesDetailsByCourtRef(courtref),
                ]);
                console.log(creatorRes, "creatorRes")
                setCreatorName(creatorRes?.data?.name || docData.createdBy || 'finding');
                setClientName(clientRes?.data?.name || docData.clientId || 'find');
                console.log(partyRes, "partyRes")
                setPartyNames(partyRes?.data?.case?.parties);
                hideLoading();
            } catch (err) {
                setError('Failed to load document details.');
                console.error(err);
                hideLoading();
            } finally {
                setLoading(false);
            }
        };

        fetchDocDetails();
    }, [id]);

    const handleFileChange = (e) => {
        const selectedFile = e.target.files[0];
        if (selectedFile) {
            setFile(selectedFile);
            uploadFile(selectedFile);
        }
    };

    const uploadFile = async (selectedFile) => {
        if (!selectedFile) return;

        setUploading(true);
        setUploadProgress(0);

        try {
            // Generate file path similar to other components
            const filePath = company._id ? `/${company._id}/others` : `/unknown`;

            await uploadFileWithProgress(
                selectedFile,
                filePath,
                // Progress callback
                (progress) => {
                    setUploadProgress(progress);
                },
                // Success callback
                (result) => {
                    console.log('File uploaded successfully:', result);
                    // Use the imageUrl from the utility function (this is what gets saved)
                    setDocumentUrl(result.imageUrl);
                    setUploading(false);
                    showToast('Upload successful!', 'success');
                },
                // Error callback
                (error) => {
                    console.error('Upload failed:', error);
                    setUploading(false);
                    setUploadProgress(0);
                    showToast(error.message || 'Upload failed!', 'error');
                }
            );

        } catch (error) {
            console.error('Upload failed:', error);
            setUploading(false);
            setUploadProgress(0);
            showToast(error.message || 'Upload failed!', 'error');
        }
    };
    const handleUploadClick = () => {
        fileInputRef.current?.click();
    };

    const handleSubmit = async () => {
        if (!documentUrl || !doc?._id) return;
        try {
            showLoading("Submitting document...");
            await uploadPendingAddDoc({ url: documentUrl }, doc._id);
            showToast('Document submitted successfully!', 'success');
            setFile(null);
            setDocumentUrl('');
            setUploading(false);
            setUploadProgress(0);
            const response = await getAddDocDetailByID(id);
            setDoc(response.data);
            hideLoading();
        } catch (error) {
            console.error('Submit failed:', error);
            showToast('Failed to submit document!', 'error');
            hideLoading();
        }
    };

    if (loading) return null;
    // if (error) return <div className="error-message">{error}</div>;

    return (
        <div className="view-add-doc-detail-container">
            <div className="view-add-doc-card">
                <div className="view-add-doc-header">
                    <div className="avatar">{doc.name?.charAt(0)}</div>
                    <div className="view-add-doc-title">
                        <h2>{doc.name}</h2>
                        <div className="view-add-doc-tag">{doc.status}</div>
                    </div>
                </div>

                <div className="view-add-doc-details-grid">
                    {/* <div className="view-note-detail-item">
                        <span className="icon">🏢</span>
                        <div>
                            <label>Company ID</label>
                            <p>{doc.companyId}</p>
                        </div>
                    </div> */}


                    <div className="view-note-detail-item">
                        <span className="icon"><FiUserPlus /></span>
                        <div>
                            <label>Created By</label>
                            <p>{creatorName}</p>
                        </div>
                    </div>

                    <div className="view-note-detail-item">
                        <span className="icon"><FiUser/></span>
                        <div>
                            <label>Client Name</label>
                            <p>{clientName}</p>
                        </div>
                    </div>

                    <div className="view-note-detail-item">
                        <span className="icon"><FiClock /></span>
                        <div>
                            <label>Created At</label>
                            <p>{new Date(doc.createdAt).toLocaleString()}</p>
                        </div>
                    </div>
                </div>
                <div className="view-note-detail-item clickable" onClick={() => navigate(`/home/cases/casedetails/${doc.courtRef}`)}>
                    <span className="icon"><FiTag /></span>
                    <div title={partyNames}>
                        <label>Court Reference</label>
                        <p >
                            {doc.courtRef} - {partyNames}
                        </p>
                    </div>
                </div>


                <div className="view-add-doc-description">
                    <strong>Description:</strong> {doc.description}
                </div>

                {doc.url && (
                    <div className="view-add-doc-document">
                        <a href={`${process.env.REACT_APP_BACKEND_MAIN_URL_PATH}ftp/view/${doc.url}`} target="_blank" rel="noopener noreferrer">
                            View Document
                        </a>
                    </div>
                )}

                {role === 'customer' && doc.status === 'Requested' && (
                    <div className="upload-section">
                        <label>Upload Document</label>
                        <div className="upload-box" onClick={handleUploadClick}>
                            <input
                                type="file"
                                ref={fileInputRef}
                                onChange={handleFileChange}
                                style={{ display: 'none' }}
                            />
                            <div className="upload-icon">
                                <BiUpload size={24} color="#0066cc" />
                                <span>Click to upload</span>
                            </div>
                        </div>

                        {uploading && (
                            <div className="upload-progress">
                                <div className="progress-bar">
                                    <div className="progress-fill" style={{ width: `${uploadProgress}%` }} />
                                </div>
                                <div className='percent-upload'><span >{Math.round(uploadProgress)}% uploaded</span></div>
                            </div>
                        )}

                        {documentUrl && !uploading && (
                            <div className="upload-result">
                                <a href={`${process.env.REACT_APP_BACKEND_MAIN_URL_PATH}ftp/view/${documentUrl}`} target="_blank" rel="noopener noreferrer">
                                    {file?.name || 'View Uploaded Document'}
                                </a>
                                <div className="upload-actions">
                                    <button onClick={() => { setFile(null); setDocumentUrl(''); }} className="cancel-btn">
                                        Delete
                                    </button>
                                    <button onClick={handleSubmit} className="submit-btn">
                                        Submit
                                    </button>
                                </div>
                            </div>
                        )}
                    </div>
                )}
            </div>
        </div>
    );
};
